import { PersistedClient, Persister } from '@tanstack/react-query-persist-client';
import { del, get, set } from 'idb-keyval';

export type IDBPersisterOptions = {
  onError?: (error: unknown) => void;
};

export function createIDBPersister(
  idbValidKey: string = 'reactQuery',
  { onError }: IDBPersisterOptions = {},
) {
  return {
    persistClient: async (client: PersistedClient) => {
      try {
        await set(idbValidKey, client);
      } catch (error) {
        onError?.(error);
      }
    },
    restoreClient: async () => {
      try {
        return await get<PersistedClient>(idbValidKey);
      } catch (error) {
        onError?.(error);
        return undefined;
      }
    },
    removeClient: async () => {
      try {
        await del(idbValidKey);
      } catch (error) {
        onError?.(error);
      }
    },
  } satisfies Persister;
}
